import React from 'react';
import './ModuleUnavailableState.scss';
import {
  MODULE_UNAVAILABLE_MESSAGE,
  MODULE_UNAVAILABLE_DESCRIPTION,
} from '../../modules/System/serviceAvailability';

export default function ModuleUnavailableState({
  title = MODULE_UNAVAILABLE_MESSAGE,
  description = MODULE_UNAVAILABLE_DESCRIPTION,
}) {
  return (
    <div className="module-unavailable-state">
      <div className="module-unavailable-state-title">{title}</div>
      <div className="module-unavailable-state-description">{description}</div>
    </div>
  );
}
